module.exports = __webpack_public_path__ + "e0ffa54e71d8c28539606c6cf25496ba.png";